module.exports = __webpack_public_path__ + "img/login-arrow.b2bd5cc0.png";